module.exports = __webpack_public_path__ + "img/58.0e4f794b.webp";